import React from 'react'
import { Menu, Layout, Icon, Badge, Button, Drawer } from 'antd'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { withRouter, Link } from 'react-router-dom'
let logo = '/images/icon/logo-q-colour.png';
let logoFull = '/images/icon/logo-colour.png';
let logoWhite = '/images/icon/logo-q-white.png'
let close = '/images/icon/close.svg'

const { Header: AntHeader } = Layout
const { Divider, Item } = Menu

const MobileMenu = ({
  t,
  contact,
  authenticated,
  logout,
  drawerVisible,
  toggleDrawer,
  active
}) => {


  let Menus = (
    <Menu
      style={{ border: 'none', background: 'transparent', textAlign: "left", marginTop: 20, height: '100%', marginLeft: -15 }}
      mode="inline"
    >
      <Item style={{fontSize: 25, fontWeight: 500, color: '#4B4B4B'}}>
        <Link to="/ben-jij-óók-op-zoek-naar-die-leukere-baan">
          {t("News")}
        </Link>
      </Item>
      <Item style={{fontSize: 25, fontWeight: 500, color: '#4B4B4B'}}>
        <Link to="/team-members">
          {t("Team")}
        </Link>
      </Item>
      <Item style={{fontSize: 25, fontWeight: 500, color: '#4B4B4B'}}>
        <Link to="/privacy-by-design">
          {t("Privacy")}
        </Link>
      </Item>
      <Item onClick={() => contact()} style={{fontSize: 25, fontWeight: 500, color: '#4B4B4B'}}>
        <a>
        {t("Contact")}
        </a>
      </Item>
      {authenticated ?
      (
        <Item onClick={() => logout()} style={{fontSize: 25, fontWeight: 500, color: '#DF0E89', position: "absolute", bottom: 10}}>
          {t("Logout")}
        </Item>
      ) :
      (
        <Item style={{position: "absolute", bottom: 10}}>
          <Link to="/login" style={{fontSize: 25, fontWeight: 500, color: '#DF0E89'}}>
            {t("sign_in")}
          </Link>
        </Item>
      )
      }

    </Menu>
  )

  const Sider = (
    <Drawer
      placement="right"
      closable={false}
      onClose={toggleDrawer}
      visible={drawerVisible}
      className="sider"
      width={326}
    >
    <div style={{display: 'flex', flexDirection: 'column'}}>
      <div
        style={{display: 'flex', justifyContent: "space-between"}}
      >
        <div>
          <Link to="/" style={{}}>
            <img src={logoFull} style={{height: '40px', width: 'auto', marginLeft: 10}}/>
          </Link>
        </div>

        <div style={{marginTop: 7}}>
          <i onClick={() => toggleDrawer()} className="collapseIcon" style={{}}>
            <img src={close} />
          </i>
        </div>

      </div>
      {Menus}
    </div>
    </Drawer>
  )

  return (
    <AntHeader
      className="header-mobile"
      style={{
        display: 'flex',
        position: 'fixed',
        width: '100%',
        background: active == 1 ? 'white' : 'linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%)',
        boxShadow: active == 1 ? '0 2px 10px 0 rgba(0,0,0,0.2)' : 'unset',
        transition: 'all0.3s',
      }}
    >
    <hr
      style={{
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
        position: 'absolute',
        bottom: 0,
        width: '97.5%',
        left: 0,
        right: 0,
        margin: '0 auto',
        display: active == 1 ? 'none' : 'unset',
      }}
    />
    {Sider}
      <div
        style={{
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Link
          to="/"
          style={{ float: 'left' }}
        >
        <img src={logo} style={{height: '36px', width: 'auto', display: active == 0 ? 'none': 'unset', transition: 'all0.3s', marginLeft: 20}}/>
        <img src={logoWhite} style={{height: '36px', width: 'auto', display: active == 1 ? 'none': 'unset', transition: 'all0.3s', marginLeft: 20}}/>
        </Link>
      </div>
      {!authenticated &&
        <div >
          <Link to="/signup" >
            <Button style={{borderRadius: 6, fontSize: 16 }} type="primary-global medium">{t("Create Account")}</Button>
          </Link>
        </div>
      }
      <Icon type="menu" onClick={() => toggleDrawer()} style={{color: active == 1 ? 'grey':'white', fontSize: 30, margin: '20px 20px'}}/>
    </AntHeader>


  )
}

export default (MobileMenu)
